import { Page } from "@/models/page-models/Page";

export const ActualUse: Page = {
  "path": "actual-use",
  "name": "Actual Use Report",
  "props": {
    "data": {
      "title": "Actual Use",
      "printable": "FALSE",
      "url": "actual-use",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Actual Use Report",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getActualUseReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Actual Use Report ",
                  "disabled": "FALSE",
                  "items": "fetchedData.actualUseReports.data",
                  "headers": [
                    {
                      "value": "rmId",
                      "text": "RM #",
                      "width": 80
                    },
                    {
                      "value": "warehouseOpeningStock",
                      "text": "Warehouse Opening Stock",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.warehouseOpeningStock}})"
                    },
                    {
                      "value": "receipts.fromSupplier",
                      "text": "Receipts From Supplier",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.receipts.fromSupplier}})"
                    },
                    {
                      "value": "receipts.fromFactory",
                      "text": "Receipts From Factory",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.receipts.fromFactory}})"
                    },
                    {
                      "value": "issues.toFactory",
                      "text": "Issues To Factory",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.issues.toFactory}})"
                    },
                    {
                      "value": "warehouseClosingStock",
                      "text": "Warehouse Closing Stock",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.warehouseClosingStock}})"
                    },
                    {
                      "value": "factoryOpeningStock",
                      "text": "Factory Opening Stock",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.factoryOpeningStock}})"
                    },
                    {
                      "value": "factoryClosingStock",
                      "text": "Factory Closing Stock",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.factoryClosingStock}})"
                    },
                    {
                      "value": "totalStock",
                      "text": "Total Stock On Hand",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalStock}})"
                    },
                    {
                      "value": "materialUsed.quantity",
                      "text": "Material Used (Quantity)",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.materialUsed.quantity}})"
                    },
                    {
                      "value": "materialUsed.value",
                      "text": "Material Used (Value)",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.materialUsed.value}})"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "functions": [
      {
        "name": "getActualUseReport",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/reports/actual-use?type=all&endDate={{formData.endDate}}&startDate={{formData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.actualUseReports"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}